"use client";
import { ThemeIllustration } from "@/components/theme-illustration";
import { cn } from "@/lib/utils";
import Link from "next/link";

type TThemesListItemProps = {
  id: number;
  name: string;
  current?: number | undefined;
  className?: string;
};

export function TopicsListItem({
  id,
  current,
  name,
  className,
}: TThemesListItemProps) {
  const href = current === id ? "/votacao" : `/votacao#tema${id}`;
  return (
    <li className="whitespace-nowrap xl:whitespace-normal snap-center">
      <Link
        key={id}
        href={href}
        className={cn(
          "flex",
          "flex-col",
          "justify-evenly",
          "items-center",
          "w-full",
          "h-30",
          "lg:h-26",
          "lg:text-sm",
          "text-xs",
          "bg-background",
          "text-wrap",
          "text-center",
          "hover:text-primary",
          "rounded-2xl",
          "transition-all",
          "overflow-hidden",
          "duration-300",
          "hover:ring-2",
          "aspect-square",
          "lg:aspect-auto",
          current === id && "font-bold text-primary",
          className
        )}
      >
        <div className="relative w-12 h-12 aspect-square">
          <ThemeIllustration type="simple" theme={name} fill />
        </div>
        <div className="px-2 text-center">{name}</div>
      </Link>
    </li>
  );
}
